export enum UserDocumentSourceType {
  FILE = 'file',
  EXTERNAL_LINK = 'external_link',
}
